// extracted by mini-css-extract-plugin
export default {"Lock_Container":"Lock_Lock_Container__+Df0z","content":"Lock_content__z02SN","accesstext":"Lock_accesstext__Qb4pV","note":"Lock_note__eNajI"};